// import Swiper from "swiper";

/* ALL THE SCRIPTS IN THIS FILE ARE MADE BY akshayvaghasiya.com --- REDISTRIBUTION IS NOT ALLOWED! */
window.theme = window.theme || {};

theme.config = {
  hasSessionStorage: true,
  youTubeReady: false,
  vimeoReady: false,
  vimeoLoading: false,
  isTouch:
    "ontouchstart" in window ||
    (window.DocumentTouch && window.document instanceof DocumentTouch) ||
    window.navigator.maxTouchPoints ||
    window.navigator.msMaxTouchPoints
      ? true
      : false,
};

if (theme.config.isTouch) {
  document.documentElement.className += " supports-touch";
}

// Cart Refresh and Build Functions
function addToCartSuccess() {
  fetch("/cart?section_id=cart-drawer")
    .then((response) => response.text())
    .then((data) => {
      const id = "CartDrawerForm";
      const html = new DOMParser().parseFromString(data, "text/html");
      const destination = document.getElementById(id);
      const source = html.getElementById(id);

      if (source && destination) destination.innerHTML = source.innerHTML;
      document.querySelector("#crt").classList.remove("loading");
    })
    .catch((e) => {
      // handle error
      console.error(e);
    });
}

function refreshCart(cart) {
  var dataURL = (this.dataURL =
    window.location.origin + "?section_id=cart-icon-bubble");
  fetch(this.dataURL)
    .then((response) => response.text())
    .then((responseText) => {
      const id = ".shopify-section";
      const html = new DOMParser().parseFromString(responseText, "text/html");
      const destination = document.getElementById("cart-icon-bubble");
      const source = html.querySelector(id);

      if (source && destination) destination.innerHTML = source.innerHTML;
    })
    .catch((e) => {
      // handle error
      console.error(e);
    })
    .finally(() => {});
}

// Trap Focus
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

// Loading Bar
class LoadingBar extends HTMLElement {
  constructor() {
    super();

    this.element = document.querySelector(".LoadingBar");
    document.addEventListener(
      "theme:loading:start",
      this.onLoadingStart.bind(this)
    );
    document.addEventListener(
      "theme:loading:end",
      this.onLoadingEnd.bind(this)
    );
    this.element.addEventListener(
      "transitionend",
      this.onTransitionEnd.bind(this)
    );
  }

  connectedCallback() {
    this.element = document.querySelector(".LoadingBar");
    document.addEventListener(
      "theme:loading:start",
      this.onLoadingStart.bind(this)
    );
    document.addEventListener(
      "theme:loading:end",
      this.onLoadingEnd.bind(this)
    );
    this.element.addEventListener(
      "transitionend",
      this.onTransitionEnd.bind(this)
    );
  }

  onLoadingStart() {
    this.element.classList.add("is-visible");
    this.element.style.width = "40%";
  }

  onLoadingEnd() {
    this.element.style.width = "100%";
    this.element.classList.add("is-finished");
  }

  onTransitionEnd(event) {
    if (
      event.propertyName === "width" &&
      this.element.classList.contains("is-finished")
    ) {
      this.element.classList.remove("is-visible");
      this.element.classList.remove("is-finished");
      this.element.style.width = "0";
    }
  }
}
customElements.define("loading-bar", LoadingBar);

class AnnouncementHeightObserver extends HTMLElement {
  constructor() {
    super();
    this._resizeObserver = new ResizeObserver(this._throttledUpdate.bind(this));
  }

  connectedCallback() {
    this._resizeObserver.observe(this);
    if (!window.ResizeObserver) {
      this._updateCustomProperties();
    }
  }

  disconnectedCallback() {
    this._resizeObserver.unobserve(this);
  }

  _throttledUpdate(entries) {
    setTimeout(this._updateCustomProperties.bind(this), 16);
  }

  _updateCustomProperties() {
    const height = this.clientHeight;
    const variable = this.getAttribute("variable");
    if (variable) {
      document.documentElement.style.setProperty(
        `--${variable}-height`,
        `${height.toFixed(2)}px`
      );
    }
  }
}

if (!customElements.get("announcement-bar")) {
  customElements.define("announcement-bar", AnnouncementHeightObserver);
}

class PromobarHeightObserver extends HTMLElement {
  constructor() {
    super();
    this._resizeObserver = new ResizeObserver(this._throttledUpdate.bind(this));
  }

  connectedCallback() {
    this._resizeObserver.observe(this);
    if (!window.ResizeObserver) {
      this._updateCustomProperties();
    }
  }

  disconnectedCallback() {
    this._resizeObserver.unobserve(this);
  }

  _throttledUpdate(entries) {
    setTimeout(this._updateCustomProperties.bind(this), 16);
  }

  _updateCustomProperties() {
    const height = this.clientHeight;
    const variable = this.getAttribute("variable");
    if (variable) {
      document.documentElement.style.setProperty(
        `--${variable}-height`,
        `${height.toFixed(2)}px`
      );
    }
  }
}

if (!customElements.get("promo-bar")) {
  customElements.define("promo-bar", PromobarHeightObserver);
}

// Theme Editor API events
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  document.addEventListener(
    "shopify:section:load",
    this._onSectionLoad.bind(this)
  );
  document.addEventListener(
    "shopify:section:unload",
    this._onSectionUnload.bind(this)
  );
  document.addEventListener(
    "shopify:section:select",
    this._onSelect.bind(this)
  );
  document.addEventListener(
    "shopify:section:deselect",
    this._onDeselect.bind(this)
  );
  document.addEventListener(
    "shopify:block:select",
    this._onBlockSelect.bind(this)
  );
  document.addEventListener(
    "shopify:block:deselect",
    this._onBlockDeselect.bind(this)
  );
};

theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var id = container.getAttribute("data-section-id");
    var type = container.getAttribute("data-section-type");

    constructor = constructor || this.constructors[type];

    if (typeof constructor === "undefined") {
      return;
    }

    var instance = Object.assign(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = document.querySelector(
      '[data-section-id="' + evt.detail.sectionId + '"]'
    );

    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    this.instances = this.instances.filter(function (instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (typeof instance.onUnload === "function") {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onSelect === "function"
    ) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onDeselect === "function"
    ) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onBlockSelect === "function"
    ) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onBlockDeselect === "function"
    ) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    document.querySelectorAll('[data-section-type="' + type + '"]').forEach(
      function (container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  },
});

theme.delegate = {
  on: function (event, callback, options) {
    if (!this.namespaces)
      // save the namespaces on the DOM element itself
      this.namespaces = {};

    this.namespaces[event] = callback;
    options = options || false;

    this.addEventListener(event.split(".")[0], callback, options);
    return this;
  },
  off: function (event) {
    if (!this.namespaces) {
      return;
    }
    this.removeEventListener(event.split(".")[0], this.namespaces[event]);
    delete this.namespaces[event];
    return this;
  },
};

// Extend the DOM with these above custom methods
window.on = Element.prototype.on = theme.delegate.on;
window.off = Element.prototype.off = theme.delegate.off;

theme.a12y = {
  trapFocus: function (options) {
    var eventsName = {
      focusin: options.namespace ? "focusin." + options.namespace : "focusin",
      focusout: options.namespace
        ? "focusout." + options.namespace
        : "focusout",
      keydown: options.namespace
        ? "keydown." + options.namespace
        : "keydown.handleFocus",
    };

    // Get every possible visible focusable element
    var focusableEls = options.container.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
    );
    var elArray = [].slice.call(focusableEls);
    var focusableElements = elArray.filter((el) => el.offsetParent !== null);

    var firstFocusable = focusableElements[0];
    var lastFocusable = focusableElements[focusableElements.length - 1];

    if (!options.elementToFocus) {
      options.elementToFocus = options.container;
    }

    options.container.setAttribute("tabindex", "-1");
    options.elementToFocus.focus();

    document.documentElement.off("focusin");
    document.documentElement.on(eventsName.focusout, function () {
      document.documentElement.off(eventsName.keydown);
    });

    document.documentElement.on(eventsName.focusin, function (evt) {
      if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;

      document.documentElement.on(eventsName.keydown, function (evt) {
        _manageFocus(evt);
      });
    });

    function _manageFocus(evt) {
      if (evt.keyCode !== 9) return;
      /**
       * On the first focusable element and tab backward,
       * focus the last element
       */
      if (evt.target === firstFocusable && evt.shiftKey) {
        evt.preventDefault();
        lastFocusable.focus();
      }
    }
  },
  removeTrapFocus: function (options) {
    var eventName = options.namespace
      ? "focusin." + options.namespace
      : "focusin";

    if (options.container) {
      options.container.removeAttribute("tabindex");
    }

    document.documentElement.off(eventName);
  },
};

// Add class when tab key starts being used to show outlines
document.documentElement.on("keyup.tab", function (evt) {
  if (evt.keyCode === 9) {
    document.documentElement.classList.add("tab-outline");
    document.documentElement.off("keyup.tab");
  }
});

theme.utils = {
  defaultTo: function (value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  },

  wrap: function (el, wrapper) {
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
  },

  debounce: function (wait, callback, immediate) {
    var timeout;
    return function () {
      var context = this,
        args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) callback.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) callback.apply(context, args);
    };
  },

  throttle: function (limit, callback) {
    var waiting = false;
    return function () {
      if (!waiting) {
        callback.apply(this, arguments);
        waiting = true;
        setTimeout(function () {
          waiting = false;
        }, limit);
      }
    };
  },

  prepareTransition: function (el, callback) {
    el.addEventListener("transitionend", removeClass);

    function removeClass(evt) {
      el.classList.remove("is-transitioning");
      el.removeEventListener("transitionend", removeClass);
    }

    el.classList.add("is-transitioning");
    el.offsetWidth; // check offsetWidth to force the style rendering

    if (typeof callback === "function") {
      callback();
    }
  },

  // _.compact from lodash
  // Creates an array with all falsey values removed. The values `false`, `null`,
  // `0`, `""`, `undefined`, and `NaN` are falsey.
  // _.compact([0, 1, false, 2, '', 3]);
  // => [1, 2, 3]
  compact: function (array) {
    var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  serialize: function (form) {
    var arr = [];
    Array.prototype.slice.call(form.elements).forEach(function (field) {
      if (
        !field.name ||
        field.disabled ||
        ["file", "reset", "submit", "button"].indexOf(field.type) > -1
      )
        return;
      if (field.type === "select-multiple") {
        Array.prototype.slice.call(field.options).forEach(function (option) {
          if (!option.selected) return;
          arr.push(
            encodeURIComponent(field.name) +
              "=" +
              encodeURIComponent(option.value)
          );
        });
        return;
      }
      if (["checkbox", "radio"].indexOf(field.type) > -1 && !field.checked)
        return;
      arr.push(
        encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value)
      );
    });
    return arr.join("&");
  },
};

theme.a11y = {
  trapFocus: function (options) {
    var eventsName = {
      focusin: options.namespace ? "focusin." + options.namespace : "focusin",
      focusout: options.namespace
        ? "focusout." + options.namespace
        : "focusout",
      keydown: options.namespace
        ? "keydown." + options.namespace
        : "keydown.handleFocus",
    };

    // Get every possible visible focusable element
    var focusableEls = options.container.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
    );
    var elArray = [].slice.call(focusableEls);
    var focusableElements = elArray.filter((el) => el.offsetParent !== null);

    var firstFocusable = focusableElements[0];
    var lastFocusable = focusableElements[focusableElements.length - 1];

    if (!options.elementToFocus) {
      options.elementToFocus = options.container;
    }

    options.container.setAttribute("tabindex", "-1");
    options.elementToFocus.focus();

    document.documentElement.off("focusin");
    document.documentElement.on(eventsName.focusout, function () {
      document.documentElement.off(eventsName.keydown);
    });

    document.documentElement.on(eventsName.focusin, function (evt) {
      if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;

      document.documentElement.on(eventsName.keydown, function (evt) {
        _manageFocus(evt);
      });
    });

    function _manageFocus(evt) {
      if (evt.keyCode !== 9) return;
      /**
       * On the first focusable element and tab backward,
       * focus the last element
       */
      if (evt.target === firstFocusable && evt.shiftKey) {
        evt.preventDefault();
        lastFocusable.focus();
      }
    }
  },
  removeTrapFocus: function (options) {
    var eventName = options.namespace
      ? "focusin." + options.namespace
      : "focusin";

    if (options.container) {
      options.container.removeAttribute("tabindex");
    }

    document.documentElement.off(eventName);
  },

  lockMobileScrolling: function (namespace, element) {
    var el = element ? element : document.documentElement;
    document.documentElement.classList.add("lock-scroll");
    el.on("touchmove" + namespace, function () {
      return true;
    });
  },

  unlockMobileScrolling: function (namespace, element) {
    document.documentElement.classList.remove("lock-scroll");
    var el = element ? element : document.documentElement;
    el.off("touchmove" + namespace);
  },
};

theme.Dom = (function () {
  /**
   * Get all the previous and next siblings, optionally filtered by a selector
   */
  function getSiblings(element, filter) {
    var includeSelf =
      arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var siblings = [];
    var currentElement = element; // Do the previous first

    while ((currentElement = currentElement.previousElementSibling)) {
      if (!filter || currentElement.matches(filter)) {
        siblings.push(currentElement);
      }
    }

    if (includeSelf) {
      siblings.push(element);
    } // Then the next side

    currentElement = element;

    while ((currentElement = currentElement.nextElementSibling)) {
      if (!filter || currentElement.matches(filter)) {
        siblings.push(currentElement);
      }
    }

    return siblings;
  }

  /**
   * By default, NodeList object are only iterable with forEach on newest browsers. To support it cross-browser,
   * we need to normalize it
   */
  function nodeListToArray(nodeList, filter) {
    var items = [];

    for (var i = 0; i !== nodeList.length; ++i) {
      if (!filter || nodeList[i].matches(filter)) {
        items.push(nodeList[i]);
      }
    }

    return items;
  }

  /**
   * Calculate an element width with its margin
   */
  function outerWidthWithMargin(element) {
    var width = element.offsetWidth,
      style = getComputedStyle(element);
    width += parseInt(style.marginLeft) + parseInt(style.marginRight);
    return width;
  }

  /**
   * Calculate an element height with its margin
   */
  function outerHeightWithMargin(element) {
    var height = element.offsetHeight,
      style = getComputedStyle(element);
    height += parseInt(style.marginTop) + parseInt(style.marginBottom);
    return height;
  }

  return {
    getSiblings: getSiblings,
    nodeListToArray: nodeListToArray,
    outerWidthWithMargin: outerWidthWithMargin,
    outerHeightWithMargin: outerHeightWithMargin,
  };
})();

theme.Drawers = (function () {
  function Drawers(id, name) {
    this.config = {
      id: id,
      close: ".js-drawer-close",
      open: ".js-drawer-open-" + name,
      openClass: "js-drawer-open",
      closingClass: "js-drawer-closing",
      activeDrawer: "drawer--is-open",
      namespace: ".drawer-" + name,
    };

    this.nodes = {
      page: document.querySelector("#MainContent"),
    };

    this.drawer = document.querySelector("#" + id);
    this.isOpen = false;

    if (!this.drawer) {
      return;
    }

    this.init();
  }

  Drawers.prototype = Object.assign({}, Drawers.prototype, {
    init: function () {
      // Setup open button(s)
      document.querySelectorAll(this.config.open).forEach((openBtn) => {
        openBtn.setAttribute("aria-expanded", "false");
        openBtn.addEventListener("click", this.open.bind(this));
      });

      this.drawer
        .querySelector(this.config.close)
        .addEventListener("click", this.close.bind(this));

      // Close modal if a drawer is opened
      document.addEventListener(
        "modalOpen",
        function () {
          this.close();
        }.bind(this)
      );
    },

    open: function (evt, returnFocusEl) {
      if (evt) {
        evt.preventDefault();
      }

      if (this.isOpen) {
        return;
      }

      // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        evt.currentTarget.setAttribute("aria-expanded", "true");
        this.activeSource = evt.currentTarget;
      } else if (returnFocusEl) {
        returnFocusEl.setAttribute("aria-expanded", "true");
        this.activeSource = returnFocusEl;
      }

      theme.utils.prepareTransition(
        this.drawer,
        function () {
          this.drawer.classList.add(this.config.activeDrawer);
        }.bind(this)
      );

      document.documentElement.classList.add(this.config.openClass);
      this.drawer.setAttribute("aria-hidden", "false");
      this.isOpen = true;

      theme.a11y.trapFocus({
        container: this.drawer,
        namespace: "drawer_focus",
      });

      document.dispatchEvent(new CustomEvent("drawerOpen"));
      document.dispatchEvent(new CustomEvent("drawerOpen." + this.config.id));

      this.bindEvents();
    },

    close: function (evt) {
      if (!this.isOpen) {
        return;
      }

      // Do not close if click event came from inside drawer
      if (evt) {
        if (evt.target.closest(".js-drawer-close")) {
          // Do not close if using the drawer close button
        } else if (evt.target.closest(".drawer")) {
          return;
        }
      }

      // deselect any focused form elements
      document.activeElement.blur();

      theme.utils.prepareTransition(
        this.drawer,
        function () {
          this.drawer.classList.remove(this.config.activeDrawer);
        }.bind(this)
      );

      document.documentElement.classList.remove(this.config.openClass);
      document.documentElement.classList.add(this.config.closingClass);
      this.drawer.setAttribute("aria-hidden", "true");

      window.setTimeout(
        function () {
          document.documentElement.classList.remove(this.config.closingClass);
          if (
            this.activeSource &&
            this.activeSource.getAttribute("aria-expanded")
          ) {
            this.activeSource.setAttribute("aria-expanded", "false");
            this.activeSource.focus();
          }
        }.bind(this),
        500
      );

      this.isOpen = false;

      theme.a11y.removeTrapFocus({
        container: this.drawer,
        namespace: "drawer_focus",
      });

      this.unbindEvents();
    },

    bindEvents: function () {
      // Clicking out of drawer closes it
      window.on(
        "click" + this.config.namespace,
        function (evt) {
          this.close(evt);
          return;
        }.bind(this)
      );

      // Pressing escape closes drawer
      window.on(
        "keyup" + this.config.namespace,
        function (evt) {
          if (evt.keyCode === 27) {
            this.close();
          }
        }.bind(this)
      );

      theme.a11y.lockMobileScrolling(this.config.namespace, this.nodes.page);
    },

    unbindEvents: function () {
      window.off("click" + this.config.namespace);
      window.off("keyup" + this.config.namespace);

      theme.a11y.unlockMobileScrolling(this.config.namespace, this.nodes.page);
    },
  });

  return Drawers;
})();

// External Libraries and Shopify Built in Libraries
theme.LibraryLoader = (function () {
  var types = {
    link: "link",
    script: "script",
  };

  var status = {
    requested: "requested",
    loaded: "loaded",
  };

  var cloudCdn = "https://cdn.shopify.com/shopifycloud/";

  var libraries = {
    youtubeSdk: {
      tagId: "youtube-sdk",
      src: "https://www.youtube.com/iframe_api",
      type: types.script,
    },
    vimeo: {
      tagId: "vimeo-api",
      src: "https://player.vimeo.com/api/player.js",
      type: types.script,
    },
    shopifyXr: {
      tagId: "shopify-model-viewer-xr",
      src: cloudCdn + "shopify-xr-js/assets/v1.0/shopify-xr.en.js",
      type: types.script,
    },
    modelViewerUi: {
      tagId: "shopify-model-viewer-ui",
      src: cloudCdn + "model-viewer-ui/assets/v1.0/model-viewer-ui.en.js",
      type: types.script,
    },
    modelViewerUiStyles: {
      tagId: "shopify-model-viewer-ui-styles",
      src: cloudCdn + "model-viewer-ui/assets/v1.0/model-viewer-ui.css",
      type: types.link,
    },
  };

  function load(libraryName, callback) {
    var library = libraries[libraryName];

    if (!library) return;
    if (library.status === status.requested) return;

    callback = callback || function () {};
    if (library.status === status.loaded) {
      callback();
      return;
    }

    library.status = status.requested;

    var tag;

    switch (library.type) {
      case types.script:
        tag = createScriptTag(library, callback);
        break;
      case types.link:
        tag = createLinkTag(library, callback);
        break;
    }

    tag.id = library.tagId;
    library.element = tag;

    var firstScriptTag = document.getElementsByTagName(library.type)[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  function createScriptTag(library, callback) {
    var tag = document.createElement("script");
    tag.src = library.src;
    tag.addEventListener("load", function () {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }

  function createLinkTag(library, callback) {
    var tag = document.createElement("link");
    tag.href = library.src;
    tag.rel = "stylesheet";
    tag.type = "text/css";
    tag.addEventListener("load", function () {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }

  return {
    load: load,
  };
})();

// Init section function when it's visible, then disable observer
theme.initWhenVisible = function (options) {
  var threshold = options.threshold ? options.threshold : 0;

  var observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (typeof options.callback === "function") {
            options.callback();
            observer.unobserve(entry.target);
          }
        }
      });
    },
    { rootMargin: "0px 0px " + threshold + "px 0px" }
  );

  observer.observe(options.element);
};

// Video Player
window.vimeoApiReady = function () {
  theme.config.vimeoLoading = true;

  // Because there's no way to check for the Vimeo API being loaded
  // asynchronously, we use this terrible timeout to wait for it being ready
  checkIfVimeoIsReady().then(function () {
    theme.config.vimeoReady = true;
    theme.config.vimeoLoading = false;
    document.dispatchEvent(new CustomEvent("vimeoReady"));
  });
};

function checkIfVimeoIsReady() {
  var wait;
  var timeout;

  var deferred = new Promise((resolve, reject) => {
    wait = setInterval(function () {
      if (!Vimeo) {
        return;
      }

      clearInterval(wait);
      clearTimeout(timeout);
      resolve();
    }, 500);

    timeout = setTimeout(function () {
      clearInterval(wait);
      reject();
    }, 4000); // subjective. test up to 8 times over 4 seconds
  });

  return deferred;
}

theme.VimeoPlayer = (function () {
  var classes = {
    loading: "loading",
    loaded: "loaded",
    interactable: "video-interactable",
  };

  var defaults = {
    background: true,
    byline: false,
    controls: false,
    loop: true,
    muted: true,
    playsinline: true,
    portrait: false,
    title: false,
  };

  function VimeoPlayer(divId, videoId, options) {
    this.divId = divId;
    this.el = document.getElementById(divId);
    this.videoId = videoId;
    this.iframe = null;
    this.options = options;

    if (this.options && this.options.videoParent) {
      this.parent = this.el.closest(this.options.videoParent);
    }

    this.setAsLoading();

    if (theme.config.vimeoReady) {
      this.init();
    } else {
      theme.LibraryLoader.load("vimeo", window.vimeoApiReady);
      document.addEventListener("vimeoReady", this.init.bind(this));
    }
  }

  VimeoPlayer.prototype = Object.assign({}, VimeoPlayer.prototype, {
    init: function () {
      var args = defaults;
      args.id = this.videoId;

      this.videoPlayer = new Vimeo.Player(this.el, args);

      this.videoPlayer.ready().then(this.playerReady.bind(this));
    },

    playerReady: function () {
      this.iframe = this.el.querySelector("iframe");
      this.iframe.setAttribute("tabindex", "-1");

      this.videoPlayer.setMuted(true);

      this.setAsLoaded();

      // pause when out of view
      var observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.play();
            } else {
              this.pause();
            }
          });
        },
        { rootMargin: "0px 0px 50px 0px" }
      );

      observer.observe(this.iframe);
    },

    setAsLoading: function () {
      if (!this.parent) return;
      this.parent.classList.add(classes.loading);
    },

    setAsLoaded: function () {
      if (!this.parent) return;
      this.parent.classList.remove(classes.loading);
      this.parent.classList.add(classes.loaded);
    },

    enableInteraction: function () {
      if (!this.parent) return;
      this.parent.classList.add(classes.interactable);
    },

    play: function () {
      if (this.videoPlayer && typeof this.videoPlayer.play === "function") {
        this.videoPlayer.play();
      }
    },

    pause: function () {
      if (this.videoPlayer && typeof this.videoPlayer.pause === "function") {
        this.videoPlayer.pause();
      }
    },

    destroy: function () {
      if (this.videoPlayer && typeof this.videoPlayer.destroy === "function") {
        this.videoPlayer.destroy();
      }
    },
  });

  return VimeoPlayer;
})();

window.onYouTubeIframeAPIReady = function () {
  theme.config.youTubeReady = true;
  document.dispatchEvent(new CustomEvent("youTubeReady"));
};

/*============================================================================
  YouTube SDK method
  Parameters:
    - player div id (required)
    - arguments
      - videoId (required)
      - videoParent (selector, optional for section loading state)
      - events (object, optional)
==============================================================================*/
theme.YouTube = (function () {
  var classes = {
    loading: "loading",
    loaded: "loaded",
    interactable: "video-interactable",
  };

  var defaults = {
    width: 1280,
    height: 720,
    playerVars: {
      autohide: 0,
      autoplay: 1,
      cc_load_policy: 0,
      controls: 0,
      fs: 0,
      iv_load_policy: 3,
      modestbranding: 1,
      playsinline: 1,
      rel: 0,
    },
  };

  function YouTube(divId, options) {
    this.divId = divId;
    this.iframe = null;

    this.attemptedToPlay = false;

    // API callback events
    defaults.events = {
      onReady: this.onVideoPlayerReady.bind(this),
      onStateChange: this.onVideoStateChange.bind(this),
    };

    this.options = Object.assign({}, defaults, options);

    if (this.options) {
      if (this.options.videoParent) {
        this.parent = document
          .getElementById(this.divId)
          .closest(this.options.videoParent);
      }

      // Most YT videos will autoplay. If in product media,
      // will handle in theme.Product instead
      if (!this.options.autoplay) {
        this.options.playerVars.autoplay = this.options.autoplay;
      }

      if (this.options.style === "sound") {
        this.options.playerVars.controls = 1;
        this.options.playerVars.autoplay = 0;
      }
    }

    this.setAsLoading();

    if (theme.config.youTubeReady) {
      this.init();
    } else {
      theme.LibraryLoader.load("youtubeSdk");
      document.addEventListener("youTubeReady", this.init.bind(this));
    }
  }

  YouTube.prototype = Object.assign({}, YouTube.prototype, {
    init: function () {
      this.videoPlayer = new YT.Player(this.divId, this.options);
    },

    onVideoPlayerReady: function (evt) {
      this.iframe = document.getElementById(this.divId); // iframe once YT loads
      this.iframe.setAttribute("tabindex", "-1");

      if (this.options.style !== "sound") {
        evt.target.mute();
      }

      // pause when out of view
      var observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.play();
            } else {
              this.pause();
            }
          });
        },
        { rootMargin: "0px 0px 50px 0px" }
      );

      observer.observe(this.iframe);
    },

    onVideoStateChange: function (evt) {
      switch (evt.data) {
        case -1: // unstarted
          // Handle low power state on iOS by checking if
          // video is reset to unplayed after attempting to buffer
          if (this.attemptedToPlay) {
            this.setAsLoaded();
            this.enableInteraction();
          }
          break;
        case 0: // ended, loop it
          this.play(evt);
          break;
        case 1: // playing
          this.setAsLoaded();
          break;
        case 3: // buffering
          this.attemptedToPlay = true;
          break;
      }
    },

    setAsLoading: function () {
      if (!this.parent) return;
      this.parent.classList.add(classes.loading);
    },

    setAsLoaded: function () {
      if (!this.parent) return;
      this.parent.classList.remove(classes.loading);
      this.parent.classList.add(classes.loaded);
    },

    enableInteraction: function () {
      if (!this.parent) return;
      this.parent.classList.add(classes.interactable);
    },

    play: function () {
      if (
        this.videoPlayer &&
        typeof this.videoPlayer.playVideo === "function"
      ) {
        this.videoPlayer.playVideo();
      }
    },

    pause: function () {
      if (
        this.videoPlayer &&
        typeof this.videoPlayer.pauseVideo === "function"
      ) {
        this.videoPlayer.pauseVideo();
      }
    },

    destroy: function () {
      if (this.videoPlayer && typeof this.videoPlayer.destroy === "function") {
        this.videoPlayer.destroy();
      }
    },
  });

  return YouTube;
})();

// Video Section
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const $this = this;
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      ).focus();
    }
  }
}
customElements.define("deferred-media", DeferredMedia);

theme.VideoSection = (function () {
  var selectors = {
    videoParent: ".Video-parent-section",
  };

  function videoSection(container) {
    this.container = container;
    this.sectionId = container.getAttribute("data-section-id");
    this.namespace = ".video-" + this.sectionId;
    this.videoObject;

    theme.initWhenVisible({
      element: this.container,
      callback: this.init.bind(this),
      threshold: 500,
    });
  }

  videoSection.prototype = Object.assign({}, videoSection.prototype, {
    init: function () {
      var dataDiv = this.container.querySelector(".video-div");
      if (!dataDiv) {
        return;
      }
      var type = dataDiv.dataset.type;

      switch (type) {
        case "youtube":
          var videoId = dataDiv.dataset.videoId;
          this.initYoutubeVideo(videoId);
          break;
        case "vimeo":
          var videoId = dataDiv.dataset.videoId;
          this.initVimeoVideo(videoId);
          break;
        case "mp4":
          this.initMp4Video();
          break;
      }
    },

    initYoutubeVideo: function (videoId) {
      this.videoObject = new theme.YouTube("YouTubeVideo-" + this.sectionId, {
        videoId: videoId,
        videoParent: selectors.videoParent,
      });
    },

    initVimeoVideo: function (videoId) {
      this.videoObject = new theme.VimeoPlayer(
        "Vimeo-" + this.sectionId,
        videoId,
        {
          videoParent: selectors.videoParent,
        }
      );
    },

    initMp4Video: function () {
      var mp4Video = "Mp4Video-" + this.sectionId;
      var mp4Div = document.getElementById(mp4Video);
      var parent = mp4Div.closest(selectors.videoParent);

      if (mp4Div) {
        parent.classList.add("loaded");

        var playPromise = document.querySelector("#" + mp4Video).play();

        // Edge does not return a promise (video still plays)
        if (playPromise !== undefined) {
          playPromise
            .then(function () {
              // playback normal
            })
            .catch(function () {
              mp4Div.setAttribute("controls", "");
              parent.classList.add("video-interactable");
            });
        }
      }
    },

    onUnload: function (evt) {
      var sectionId = evt.target.id.replace("shopify-section-", "");
      if (this.videoObject && typeof this.videoObject.destroy === "function") {
        this.videoObject.destroy();
      }
    },
  });

  return videoSection;
})();

theme.collapsibles = (function () {
  var selectors = {
    trigger: ".collapsible-trigger",
    module: ".collapsible-content",
    moduleInner: ".collapsible-content__inner",
    tabs: ".collapsible-trigger--tab",
  };

  var classes = {
    hide: "hide",
    open: "is-open",
    autoHeight: "collapsible--auto-height",
    tabs: "collapsible-trigger--tab",
    parentActive: "is-active",
  };

  var namespace = ".collapsible";

  var isTransitioning = false;

  function init(scope) {
    var el = scope ? scope : document;
    el.querySelectorAll(selectors.trigger).forEach((trigger) => {
      var state = trigger.classList.contains(classes.open);
      trigger.setAttribute("aria-expanded", state);

      trigger.off("click" + namespace);
      trigger.on("click" + namespace, toggle);
    });
  }

  function toggle(evt) {
    if (isTransitioning) {
      return;
    }

    isTransitioning = true;

    var el = evt.currentTarget;
    var isOpen = el.classList.contains(classes.open);
    var isTab = el.classList.contains(classes.tabs);
    var moduleId = el.getAttribute("aria-controls");
    var container = document.getElementById(moduleId);

    if (!moduleId) {
      moduleId = el.dataset.controls;
    }

    // No ID, bail
    if (!moduleId) {
      return;
    }

    if (!container) {
      var multipleMatches = document.querySelectorAll(
        '[data-id="' + moduleId + '"]'
      );
      if (multipleMatches.length > 0) {
        container = el.parentNode.querySelector('[data-id="' + moduleId + '"]');
      }
    }

    if (!container) {
      isTransitioning = false;
      return;
    }

    // ✅ Auto-close any other open accordion (skip tabs, they handle their own logic)
    if (!isTab && !isOpen) {
      document.querySelectorAll(selectors.trigger + "." + classes.open).forEach((openTrigger) => {
        if (openTrigger === el) return; // skip self

        var openModuleId = openTrigger.getAttribute("aria-controls") || openTrigger.dataset.controls;
        var openContainer = document.getElementById(openModuleId) ||
          openTrigger.parentNode.querySelector('[data-id="' + openModuleId + '"]');

        if (openContainer) {
          openTrigger.setAttribute("aria-expanded", false);
          openTrigger.classList.remove(classes.open);
          openTrigger.parentElement.classList.remove(classes.parentActive);
          setTransitionHeight(openContainer, 0, true, false);
        }
      });
    }

    var height = container.querySelector(selectors.moduleInner).offsetHeight;
    var isAutoHeight = container.classList.contains(classes.autoHeight);
    var parentCollapsibleEl = container.parentNode.closest(selectors.module);
    var childHeight = height;

    if (isTab) {
      if (isOpen) {
        isTransitioning = false;
        return;
      }

      var newModule;
      document
        .querySelectorAll(selectors.tabs + '[data-id="' + el.dataset.id + '"]')
        .forEach((el) => {
          el.classList.remove(classes.open);
          newModule = document.querySelector(
            "#" + el.getAttribute("aria-controls")
          );
          setTransitionHeight(newModule, 0, true);
        });
    }

    if (isOpen && isAutoHeight) {
      setTimeout(function () {
        height = 0;
        setTransitionHeight(container, height, isOpen, isAutoHeight);
      }, 0);
    }

    if (isOpen && !isAutoHeight) {
      height = 0;
    }

    el.setAttribute("aria-expanded", !isOpen);
    if (isOpen) {
      el.classList.remove(classes.open);
      el.parentElement.classList.remove(classes.parentActive);
    } else {
      el.classList.add(classes.open);
      el.parentElement.classList.add(classes.parentActive);
    }

    setTransitionHeight(container, height, isOpen, isAutoHeight);

    if (parentCollapsibleEl) {
      var totalHeight = isOpen
        ? parentCollapsibleEl.offsetHeight - childHeight
        : height + parentCollapsibleEl.offsetHeight;

      setTransitionHeight(parentCollapsibleEl, totalHeight, false, false);
    }
  }

  function setTransitionHeight(container, height, isOpen, isAutoHeight) {
    container.classList.remove(classes.hide);
    theme.utils.prepareTransition(container, function () {
      container.style.height = height + "px";
      if (isOpen) {
        container.classList.remove(classes.open);
      } else {
        container.classList.add(classes.open);
      }
    });

    if (!isOpen && isAutoHeight) {
      var o = container;
      window.setTimeout(function () {
        o.css("height", "auto");
        isTransitioning = false;
      }, 500);
    } else {
      isTransitioning = false;
    }
  }

  return {
    init: init,
  };
})();

theme.HeaderSection = (function() {

  function HeaderSection(container) {
    var _this = this;

    this.element = container;
    this.delegateElement = new Delegate(this.element);
  
    this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
    this.lastScrollPosition = -1;
    this.isTouch = window.matchMedia('(-moz-touch-enabled: 1), (hover: none)').matches;

    if (this.options['isSticky']) {
      //Stickyfill.addOne(this.element.parentNode);
    }

    this._attachListeners();

    this._verifyNavigationOverlap(); // We set again some CSS variables that are used for some calculations in CSS
    
    var mainLogo = this.element.querySelector('.Header__LogoImage--primary');

    if (mainLogo && !mainLogo.complete) {
      mainLogo.addEventListener('load', function () {
        fastdom.measure(function () {
          document.documentElement.style.setProperty('--header-height', _this.element.clientHeight + 'px');
          document.documentElement.style.setProperty('--header-is-not-transparent', _this.options['hasTransparentHeader'] ? 0 : 1);
        });
      });
    } else {
      fastdom.measure(function () {
        document.documentElement.style.setProperty('--header-height', _this.element.clientHeight + 'px');
        document.documentElement.style.setProperty('--header-is-not-transparent', _this.options['hasTransparentHeader'] ? 0 : 1);
      });
    }

    var mobileNavigationElement = this.element.querySelector('.header__mobile-nav');

    // if (mobileNavigationElement) {
    //   this.mobileNavigation = new theme.MobileNavigation(mobileNavigationElement);
    // }

    window.addEventListener('pageshow', this._checkTransparentHeader.bind(this));
  }
  
  HeaderSection.prototype = Object.assign({}, HeaderSection.prototype, {
    onUnload: function() {
      this.element.removeEventListener('mouseleave', this._closeNavigationListener);
      this.element.removeEventListener('mouseenter', this._focusNavigationListener);
      this.element.removeEventListener('focusin', this._focusNavigationListener);
      this.delegateElement.off();
      window.removeEventListener('scroll', this._checkTransparentHeaderListener);
      window.removeEventListener('resize', this._verifyNavigationOverlapListener);

      if (this.options['isSticky']) {
        //Stickyfill.removeOne(this.element.parentNode);
      }

      // if (this.mobileNavigation) {
      //   this.mobileNavigation.destroy();
      // }

    },

    onSelect: function() {
      this._checkTransparentHeader();
    },

    // eslint-disable-next-line no-unused-vars
    onBlockSelect: function(event) {
      var _this2 = this;

      var listItem = event.target.closest('.HorizontalList__Item');
      fastdom.mutate(function () {
        event.target.setAttribute('aria-hidden', 'false');

        if (listItem) {
          listItem.classList.add('is-expanded');
          theme.Dom.getSiblings(listItem, '.is-expanded').forEach(function (item) {
            item.classList.remove('is-expanded');
          });
        }

        _this2.element.classList.remove('Header--transparent'); // This is needed to make sure everything is visible

      });
    },

    onBlockDeselect: function(event) {
      var listItem = event.target.closest('.HorizontalList__Item');
      fastdom.mutate(function () {
        event.target.setAttribute('aria-hidden', 'true');

        if (listItem) {
          listItem.classList.remove('is-expanded');
        }
      });

      this._checkTransparentHeader();
    },

    _attachListeners: function() {
      this._checkTransparentHeaderListener = this._checkTransparentHeader.bind(this);
      this._closeNavigationListener = this._closeNavigation.bind(this);
      this._focusNavigationListener = this._focusNavigation.bind(this);
      this._verifyNavigationOverlapListener = this._verifyNavigationOverlap.bind(this);
      this.element.addEventListener('mouseleave', this._closeNavigationListener);
      this.delegateElement.on('mouseenter', '.Header__MainNav .HorizontalList__Item, [aria-haspopup]', this._openMenu.bind(this), true);
      this.delegateElement.on('focusin', '[aria-haspopup]', this._openMenu.bind(this), true);
      this.delegateElement.on('focusout', '[aria-haspopup]', this._closeMenu.bind(this), false);
      // this.delegateElement.on('click', '[data-action="toggle-search"]', this._closeNavigationListener);
      this.delegateElement.on('mouseleave', '.DropdownMenu [aria-haspopup]', this._closeMenu.bind(this), true);
      this.delegateElement.on('mouseenter', '.DropdownMenu [aria-haspopup]', this._adjustDropdownPosition.bind(this), true);
      this.delegateElement.on('click', '[data-action="toggle-menu"]', this._focusMobileNavigation.bind(this));

      if (this.isTouch) {
        this.delegateElement.on('click', '.Header__MainNav [aria-haspopup]', this._handleTouchMenu.bind(this));
      }

      if (this.options['hasTransparentHeader']) {
        this.element.addEventListener('mouseenter', this._focusNavigationListener);
        this.element.addEventListener('focusin', this._focusNavigationListener);
      }

      if (this.options['isSticky'] && this.options['hasTransparentHeader']) {
        window.addEventListener('scroll', this._checkTransparentHeaderListener);
      }

      if (this.options['navigationStyle'] === 'inline' || this.options['navigationStyle'] === 'logoLeft') {
        window.addEventListener('resize', this._verifyNavigationOverlapListener);
      }
    },

    _focusNavigation: function() {
      var _this3 = this;

      fastdom.mutate(function () {
        // if (!_this3.isTouch || window.matchMedia('screen and (min-width: 1008px)').matches) {
        //   _this3.element.classList.remove('Header--transparent');
        // }
        _this3.element.classList.remove('Header--transparent');
      });
    },

    
    _focusMobileNavigation: function() {
        var _this7 = this;
        
      
        fastdom.mutate(function () {
          if(_this7.element.classList.contains('Header--transparent')) {
            _this7.element.classList.remove('Header--transparent');
          }
        });
    },

    _closeNavigation: function() {
      var _this4 = this;

      fastdom.mutate(function () {
        theme.Dom.nodeListToArray(_this4.element.querySelectorAll('.is-expanded')).forEach(function (item) {
          item.classList.remove('is-expanded');
        });
        theme.Dom.nodeListToArray(_this4.element.querySelectorAll('.Header__MainNav [aria-hidden="false"]')).forEach(function (item) {
          item.setAttribute('aria-hidden', 'true');
        });
      });

      if (this.options['hasTransparentHeader']) {
        this._checkTransparentHeader();
      }
    },

    _openMenu: function(event, target) {
      if (event.type === 'mouseenter' && target !== event.target) {
          return;
        }

        fastdom.mutate(function () {
          target.classList.add('is-expanded');

          theme.Dom.nodeListToArray(target.children, '.Header__MainNav [aria-hidden="true"]').forEach(function (item) {
            item.setAttribute('aria-hidden', 'false');
          });
          theme.Dom.getSiblings(target, '.is-expanded').forEach(function (item) {
            item.classList.remove('is-expanded');
            theme.Dom.nodeListToArray(item.children, '.Header__MainNav [aria-hidden="false"]').forEach(function (item) {
              item.setAttribute('aria-hidden', 'true');
            });
          });
        });
    },

    _closeMenu: function(event, target) {
      if (event.type === 'mouseleave' && target !== event.target) {
          return;
      }

      fastdom.mutate(function () {
        target.classList.remove('is-expanded');
        theme.Dom.nodeListToArray(target.children, '.Header__MainNav [aria-hidden="false"]').forEach(function (item) {
          item.setAttribute('aria-hidden', 'true');
        });
      });
    },

    _adjustDropdownPosition: function(event, target) {
          var nestedMenus = theme.Dom.nodeListToArray(target.querySelectorAll('.DropdownMenu')),
          shouldOpenLeft = false;
      fastdom.measure(function () {
          var windowWidth = window.innerWidth,
              rightEdge = target.getBoundingClientRect().right;
          nestedMenus.forEach(function (item) {
          if (rightEdge + item.offsetWidth > windowWidth) {
              shouldOpenLeft = true;
          }
          });
      });
      fastdom.mutate(function () {
          if (shouldOpenLeft) {
          nestedMenus.forEach(function (item) {
              item.classList.add('DropdownMenu--reversed');
          });
          } else {
          nestedMenus.forEach(function (item) {
              item.classList.remove('DropdownMenu--reversed');
          });
          }
      });
    },

    _handleTouchMenu: function(event, target) {
      if (!target.classList.contains('is-expanded')) {
          event.preventDefault();
        }
    },

    _verifyNavigationOverlap: function() {
      var _this5 = this;

      var isOverlapping = false,
          mainTopMenu = this.element.querySelector('.Header__MainNav');
      fastdom.measure(function () {
        // To detect if the navigation is overlapping, we take the height of a single item and check if its height is taller than the parent
        if (mainTopMenu) {
          // Get the first element
          var firstNavElementHeight = theme.Dom.outerHeightWithMargin(mainTopMenu.querySelector('.HorizontalList__Item')),
              mainNavHeight = mainTopMenu.scrollHeight;

          if (mainNavHeight > firstNavElementHeight) {
            isOverlapping = true;
          }
        }
      });
      this.element.classList.remove('Header--logoLeft', 'Header--inline', 'Header--center');
      this.element.classList.add("Header--".concat(this.options['navigationStyle']));
      this.element.clientWidth; // Forces a reflow

      fastdom.mutate(function () {
        if (isOverlapping) {
          _this5.element.classList.remove("Header--".concat(_this5.options['navigationStyle']));

          _this5.element.classList.add('Header--center'); // Check if still overlapping despite changing the mode


          if (mainTopMenu) {
            // Get the first element
            var itemTopSet = new Set();
            Array.from(mainTopMenu.querySelectorAll('.HorizontalList__Item')).forEach(function (item) {
              itemTopSet.add(item.getBoundingClientRect().top);
            });
            isOverlapping = itemTopSet.size > 1;
          }
        } else {
          _this5.element.classList.add("Header--".concat(_this5.options['navigationStyle']));

          _this5.element.classList.remove('Header--center');
        }

        _this5.element.classList.add('Header--initialized');

        fastdom.measure(function () {
          document.documentElement.style.setProperty('--header-height', _this5.element.clientHeight + 'px');
        });
      });
    },

    _checkTransparentHeader: function() {
      var _this6 = this;

      if (!this.options['hasTransparentHeader']) {
        return;
      }

      var scrollThreshold = 10;
      fastdom.measure(function () {
        _this6.lastScrollPosition = window.pageYOffset;
      });
      fastdom.mutate(function () {
        if (_this6.lastScrollPosition <= scrollThreshold) {
          _this6.element.classList.add('Header--transparent');
        } else {
          _this6.element.classList.remove('Header--transparent');
        }
      });
    }

  });

  return HeaderSection;
})();

theme.CollectionListSlider = (function () {
  function CollectionListSlider(container) {
    var sectionId = container.dataset.sectionId;
    this.container = container;
    var slideshow = (this.slideshow = "#CollectionList-" + sectionId);
    var CollectionList = this.CollectionListSlider;

    this.CollectionListSlider = new Swiper(slideshow, {
      slidesPerView: 1,
      spaceBetween: 0,
      grabCursor: false,
      keyboard: {
        enabled: true,
      },
      touchEventsTarget: container,
      allowTouchMove: true,
      preventInteractionOnTransition: false,
      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 640px
        641: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        1008: {
          slidesPerView: 2,
          spaceBetween: 50,
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 50,
        },
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        dragSize: "auto",
      },
      navigation: {
        nextEl: ".slide-button-next",
        prevEl: ".slide-button-prev",
      },
    });
  }

  return CollectionListSlider;
})();

theme.CollectionListSlider.prototype = Object.assign(
  {},
  theme.CollectionListSlider.prototype,
  {
    onUnload: function () {
      this.CollectionListSlider.destroy(true);
    },

    onBlockSelect: function (evt) {
      // Get slide's index using theme editor's id
      // Go to selected slide, pause auto-rotate
      var slideIndex = evt.target.getAttribute("data-slide-index");
      this.CollectionListSlider.slideTo(slideIndex - 1, 400, true);
    },

    onBlockDeselect: function (evt) {
      // Resume Slideshow events
      this.CollectionListSlider.update();
    },
  }
);

theme.CartDrawer = (function () {
  var selectors = {
    drawer: "#CartDrawer",
    form: "#CartDrawerForm",
  };

  function CartDrawer() {
    this.form = document.querySelector(selectors.form);
    this.drawer = new theme.Drawers("CartDrawer", "cart");

    this.init();
  }

  CartDrawer.prototype = Object.assign({}, CartDrawer.prototype, {
    init: function () {
      document.addEventListener(
        "product:added",
        function (evt) {
          this.open();
        }.bind(this)
      );

      // Dev-friendly way to open cart
      document.addEventListener("cart:open", this.open.bind(this));
      document.addEventListener("cart:close", this.close.bind(this));
    },

    open: function () {
      this.drawer.open();
    },

    close: function () {
      this.drawer.close();
    },
  });

  return CartDrawer;
})();

theme.CartDrawerAjax = /*#__PURE__*/ (function () {
  function CartDrawerAjax(container) {
    this.element = container;
    this.delegateElement = new Delegate(this.element);
    this.documentDelegate = new Delegate(document.documentElement);
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.itemCount = this.options["itemCount"];

    if (this.options["drawer"]) {
      if (!document.body.classList.contains("template-cart")) {
        this.sidebarDrawer = new theme.CartDrawer();
      }
    }

    this._attachListeners();
  }

  CartDrawerAjax.prototype = Object.assign({}, CartDrawerAjax.prototype, {
    onUnload: function onUnload() {
      this.delegateElement.off();
      document.removeEventListener(
        "product:added",
        this._onProductAddedListener
      );
    },

    _attachListeners: function _attachListeners() {
      this._onProductAddedListener = this._onProductAdded.bind(this);

      if (this.options["type"] !== "page") {
        this.delegateElement.on(
          "click",
          '[data-action="update-item-quantity"], [data-action="remove-item"]',
          this._updateItemQuantity.bind(this)
        );
        this.delegateElement.on(
          "change",
          ".QuantitySelector__CurrentQuantity",
          this._updateItemQuantity.bind(this)
        );
      } else {
        this.delegateElement.on(
          "change",
          ".QuantitySelector__CurrentQuantity",
          this._reloadPageWithQuantity.bind(this)
        );
      } // We have some listeners that are specific to the fact it's a drawer or the dedicated cart page

      document.addEventListener("product:added", this._onProductAddedListener); // We attach a listener at page level which allows to re-render the cart

      this.documentDelegate.on(
        "cart:refresh",
        this._rerenderCart.bind(this, false)
      );
    },

    _updateItemQuantity: function _updateItemQuantity(event, target) {
      var _this2 = this;

      document.dispatchEvent(new CustomEvent("theme:loading:start"));
      var quantity = null,
        elementToAnimate = null;

      if (target.tagName === "INPUT") {
        quantity = parseInt(Math.max(parseInt(target.value) || 1, 1));
      } else {
        quantity = parseInt(target.getAttribute("data-quantity"));
      } // If the quantity is 0, then we will animate the product with a removal effect

      if (quantity === 0) {
        elementToAnimate = target.closest(".CartItemWrapper");
      }

      fetch("".concat(window.routes.cart_change_url, ".js"), {
        body: JSON.stringify({
          line: target.getAttribute("data-line"),
          quantity: quantity,
        }),
        credentials: "same-origin",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
        },
      }).then(function (cart) {
        cart.json().then(function (content) {
          _this2.itemCount = content["item_count"];

          _this2._rerenderCart(elementToAnimate);

          document.dispatchEvent(new CustomEvent("theme:loading:end"));
        });
      });
      event.preventDefault();
    },

    _reloadPageWithQuantity: function _reloadPageWithQuantity(event, target) {
      window.location.href = ""
        .concat(window.routes.cart_change_url, "?quantity=")
        .concat(parseInt(target.value), "&line=")
        .concat(target.getAttribute("data-line"));
    },

    _onProductAdded: function _onProductAdded(event) {
      var _this3 = this;

      this.itemCount += event.detail.quantity;

      this._rerenderCart().then(function () {
        _this3.sidebarDrawer.open();
      });
      document.dispatchEvent(new CustomEvent("cart:drawer:updated"));
    },

    /**
     * This method is called internally to rerender the cart, based on the content returned by Shopify Ajax API.
     * We could save some performance by updating directly in JavaScript instead of doing a GET call to get the HTML
     * from Shopify, but by experience, this allows for easier app integration as it allows the Liquid to re-run
     * all the time and hence having easier logic.
     */

    _rerenderCart: function _rerenderCart(elementToAnimate) {
      var _this4 = this;

      // Note: appending a timestamp is necessary as the polyfill on IE11 and lower does not support the "cache" property
      return fetch(
        ""
          .concat(window.routes.cartUrl, "?section_id=")
          .concat(
            this.options["drawer"] && window.theme.pageType !== "cart"
              ? "cart-drawer"
              : "main-cart"
          ),
        {
          credentials: "same-origin",
          method: "GET",
        }
      ).then(function (content) {
        content.text().then(function (html) {
          _this4._replaceContent(html);
        });
      });
    },

    _replaceContent: function _replaceContent(html) {
      var _this5 = this;

      var tempElement = document.createElement("div");
      tempElement.innerHTML = html;
      var cartNodeParent = this.element.querySelector(".Cart").parentNode;

      if (this.options["drawer"] && window.theme.pageType !== "cart") {
        var currentScrollPosition =
          this.element.querySelector(".Drawer__Main").scrollTop;
        cartNodeParent.replaceChild(
          tempElement.querySelector(".Cart"),
          this.element.querySelector(".Cart")
        );
        this.element.querySelector(".Drawer__Main").scrollTop =
          currentScrollPosition;
      }

      // We can also update the dot and the quantity
      var cartResult = JSON.parse(
        tempElement
          .querySelector('[data-section-type="cart-drawer"]')
          .getAttribute("data-section-settings")
      );
      var cartDot = theme.Dom.nodeListToArray(
        document.querySelectorAll(".Header__CartDot")
      );
      var EmptyCart = theme.Dom.nodeListToArray(
        document.querySelectorAll(".empty-cart")
      );
      var NonEmptyCart = theme.Dom.nodeListToArray(
        document.querySelectorAll(".nonempty-cart")
      );

      this.itemCount = cartResult["itemCount"];
      cartDot.forEach(function (item) {
        if (_this5.itemCount === 0) {
          item.classList.remove("is-visible"); // IE 11 and lower does not support second attribute of toggle :(
        } else {
          item.classList.add("is-visible");
        }
      });
      EmptyCart.forEach(function (item) {
        if (_this5.itemCount === 0) {
          item.classList.remove("hidden"); // IE 11 and lower does not support second attribute of toggle :(
        } else {
          item.classList.add("hidden");
        }
      });
      NonEmptyCart.forEach(function (item) {
        if (_this5.itemCount === 0) {
          item.classList.add("hidden"); // IE 11 and lower does not support second attribute of toggle :(
        } else {
          item.classList.remove("hidden");
        }
      });
      cartDot.forEach(function (item) {
        item.textContent = _this5.itemCount;
      });
    },
  });

  return CartDrawerAjax;
})();

theme.Testimonial = (function () {
  function Testimonial(container) {
    var sectionId = container.dataset.sectionId;
    this.container = container;
    var slideshow = (this.slideshow = "#Testimonial-" + sectionId);
    var TestimonialSlider = this.TestimonialSlider;

    this.TestimonialSlider = new Swiper(slideshow, {
      slidesPerView: 1,
      spaceBetween: 0,
      grabCursor: false,
      keyboard: {
        enabled: true,
      },
      touchEventsTarget: container,
      allowTouchMove: true,
      preventInteractionOnTransition: false,
      navigation: {
        nextEl: ".slide-button-next",
        prevEl: ".slide-button-prev",
      },
    });

    this.TestimonialSlider.update();
  }

  return Testimonial;
})();

theme.Testimonial.prototype = Object.assign({}, theme.Testimonial.prototype, {
  onUnload: function () {
    this.TestimonialSlider.destroy(true);
  },

  onBlockSelect: function (evt) {
    // Get slide's index using theme editor's id
    // Go to selected slide, pause auto-rotate
    var slideIndex = evt.target.getAttribute("data-slide-index");
    this.TestimonialSlider.slideTo(slideIndex - 1, 400, true);
  },

  onBlockDeselect: function (evt) {
    // Resume Slideshow events
    this.TestimonialSlider.update();
  },
});

theme.Slideshow = (function () {
  function Slideshow(container) {
    var sectionId = container.dataset.sectionId;
    this.container = container;
    var slideshow = (this.slideshow = "#Slideshow-" + sectionId);
    var SlideshowSlider = this.SlideshowSlider;

    this.SlideshowSlider = new Swiper(slideshow, {
      slidesPerView: 1,
      spaceBetween: 0,
      grabCursor: false,
      keyboard: {
        enabled: true,
      },
      touchEventsTarget: container,
      allowTouchMove: true,
      preventInteractionOnTransition: false,
      navigation: {
        nextEl: ".slide-button-next",
        prevEl: ".slide-button-prev",
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        dragSize: "auto",
      },
    });

    this.SlideshowSlider.update();
  }

  return Slideshow;
})();

theme.Slideshow.prototype = Object.assign({}, theme.Slideshow.prototype, {
  onUnload: function () {
    this.SlideshowSlider.destroy(true);
  },

  onBlockSelect: function (evt) {
    // Get slide's index using theme editor's id
    // Go to selected slide, pause auto-rotate
    var slideIndex = evt.target.getAttribute("data-slide-index");
    this.SlideshowSlider.slideTo(slideIndex - 1, 400, true);
  },

  onBlockDeselect: function (evt) {
    // Resume Slideshow events
    this.SlideshowSlider.update();
  },
});

theme.SecondSlideshow = (function () {
  function SecondSlideshow(container) {
    var sectionId = container.dataset.sectionId;
    this.container = container;
    var slideshow = (this.slideshow = "#slideshow-" + sectionId);
    var SlideshowSlider = this.SlideshowSlider;

    this.SlideshowSlider = new Swiper(slideshow, {
      slidesPerView: 1,
      spaceBetween: 10,
      grabCursor: false,
      keyboard: {
        enabled: true,
      },
      touchEventsTarget: container,
      allowTouchMove: true,
      preventInteractionOnTransition: false,
      navigation: {
        nextEl: ".slide-button-next",
        prevEl: ".slide-button-prev",
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        dragSize: "auto",
      },
    });

    this.SlideshowSlider.update();
  }

  return SecondSlideshow;
})();

theme.SecondSlideshow.prototype = Object.assign(
  {},
  theme.SecondSlideshow.prototype,
  {
    onUnload: function () {
      this.SlideshowSlider.destroy(true);
    },

    onBlockSelect: function (evt) {
      // Get slide's index using theme editor's id
      // Go to selected slide, pause auto-rotate
      var slideIndex = evt.target.getAttribute("data-slide-index");
      this.SlideshowSlider.slideTo(slideIndex - 1, 400, true);
    },

    onBlockDeselect: function (evt) {
      // Resume Slideshow events
      this.SlideshowSlider.update();
    },
  }
);

theme.ProductListSlider = (function () {
  function ProductListSlider(container) {
    var sectionId = container.dataset.sectionId;
    this.container = container;
    var slideshow = (this.slideshow = "#ProductList-" + sectionId);
    var ProductList = this.ProductListSlider;

    this.ProductListSlider = new Swiper(slideshow, {
      slidesPerView: 1.25,
      spaceBetween: 20,
      grabCursor: false,
      keyboard: {
        enabled: true,
      },
      touchEventsTarget: container,
      allowTouchMove: true,
      preventInteractionOnTransition: false,
      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 640px
        641: {
          slidesPerView: 2.5,
          spaceBetween: 30,
        },
        1008: {
          slidesPerView: 2.5,
          spaceBetween: 50,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        dragSize: "auto",
      },
      navigation: {
        nextEl: ".slide-button-next",
        prevEl: ".slide-button-prev",
      },
    });
  }

  return ProductListSlider;
})();

theme.ProductListSlider.prototype = Object.assign(
  {},
  theme.ProductListSlider.prototype,
  {
    onUnload: function () {
      this.ProductListSlider.destroy(true);
    },

    onBlockSelect: function (evt) {
      // Get slide's index using theme editor's id
      // Go to selected slide, pause auto-rotate
      var slideIndex = evt.target.getAttribute("data-slide-index");
      this.ProductListSlider.slideTo(slideIndex - 1, 400, true);
    },

    onBlockDeselect: function (evt) {
      // Resume Slideshow events
      this.ProductListSlider.update();
    },
  }
);

theme.DescriptionTabs = (function () {
  function DescriptionTabs(container) {
    var selectors = {
      tab_list: "[data-tablist]",
      tab_links: document.querySelectorAll("[data-tablist] li"),
      tab_content: document.querySelectorAll("[data-tabcontent]"),
    };

    selectors.tab_links.forEach(function (tabLink) {
      tabLink.addEventListener("click", function () {
        var tab_id = this.getAttribute("data-tab");
        selectors.tab_links.forEach(function (link) {
          link.classList.remove("active");
        });
        selectors.tab_content.forEach(function (content) {
          content.classList.remove("current");
        });
        this.classList.add("active");
        document.getElementById(tab_id).classList.add("current");
      });
    });
  }

  return DescriptionTabs;
})();

// Size guide toogle Tabs code starts here
class SizeTabs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.selectors = {
      tabList: "[data-tablist]",
      tabLinks: '[data-action="toggle-tabs"]',
      tabContent: "[data-tabcontent]",
    };

    this.querySelectorAll(this.selectors.tabLinks).forEach((currentTab) =>
      currentTab.addEventListener("click", this.onTabClick.bind(this))
    );
  }

  onTabClick(event) {
    event.preventDefault();
    var target = event.target;
    var tabId = target.getAttribute("aria-controls");

    // We remove active attribute from all siblings
    var targetSiblings = this.getSiblings(target);
    for (const targetSibling of targetSiblings) {
      targetSibling.classList.remove("Active__Toggle");
    }

    // We remove current attribute from all content tabs
    var tabContents = this.querySelectorAll(this.selectors.tabContent);
    for (const tabContent of tabContents) {
      tabContent.classList.remove("is-current");
    }

    target.classList.add("Active__Toggle");
    this.querySelector(`#${tabId}`).classList.add("is-current");
  }

  getSiblings(e) {
    // for collecting siblings
    let siblings = [];
    // if no parent, return no sibling
    if (!e.parentNode) {
      return siblings;
    }
    // first child of the parent node
    let sibling = e.parentNode.firstChild;
    // collecting siblings
    while (sibling) {
      if (sibling.nodeType === 1 && sibling !== e) {
        siblings.push(sibling);
      }
      sibling = sibling.nextSibling;
    }
    return siblings;
  }
}

// Upgrade all div elements with the custom "is" attribute to a custom element
const sizeChartDivs = document.querySelectorAll('div[is="size-chart"]');

// Define a function to create a new <size-chart> element and replace the original div
function upgradeSizeChartDiv(div) {
  const sizeChart = document.createElement("size-chart");

  // Use the spread operator to copy all attributes from the original div to the new size-chart element
  // [...div.attributes].forEach((attr) => sizeChart.setAttribute(attr.name, attr.value));

  // Use the spread operator to move all children from the original div to the new size-chart element
  sizeChart.append(...div.childNodes);

  // Replace the original div with the new size-chart element
  div.parentNode.replaceChild(sizeChart, div);
}

// Loop through each div and upgrade it to a <size-chart> element
sizeChartDivs.forEach(upgradeSizeChartDiv);

// Define the custom element (if required)
customElements.define("size-chart", SizeTabs);


// Expose globally for popup injection use
window.upgradeSizeChartDiv = upgradeSizeChartDiv;
// Size guide toogle Tabs code ends here

theme.NewsletterPopupSection = (function () {
  function NewsletterPopupSection(element) {
    var sectionId = element.dataset.sectionId;
    this.element = element;
    this.options = JSON.parse(element.getAttribute("data-section-settings"));

    var cookie_expire = 7; // days

    var cookie = localStorage.getItem("newsletter");
    if (cookie == undefined || cookie == null) {
      cookie = 0;
    }

    // If user submit form, we do not display it again till next 7 days
    if (
      (new Date().getTime() - cookie) / (1000 * 60 * 60 * 24) >
      cookie_expire
    ) {
      // If the popup has been already displayed, we do not display it
      try {
        if (
          window.location.hash === "#newsletter-popup" &&
          window.theme.template !== null
        ) {
          this._openPopup();
        } else if (
          !this.options["showOnlyOnce"] ||
          (this.options["showOnlyOnce"] &&
            localStorage.getItem("themePopup") === null)
        ) {
          setTimeout(
            this._openPopup.bind(this),
            this.options["apparitionDelay"] * 1000
          );
        } else {
          setTimeout(
            this._openPopup.bind(this),
            this.options["apparitionDelay"] * 1000
          );
        }
      } catch (error) {
        console.log(error);
        // Some browsers (especially in private mode) throw an exception when trying to access local storage, so we protect ourselves here
      }
    }
    this._attachListeners();
  }

  return NewsletterPopupSection;
})();

theme.NewsletterPopupSection.prototype = Object.assign(
  {},
  theme.NewsletterPopupSection.prototype,
  {
    onUnload: function () {
      // Remove all events from elements
      document
        .querySelector('[data-action="close-popup"]')
        .removeEventListener("click", this._closePopup.bind(this));
    },

    onSelect: function () {
      this._openPopup();
    },

    onDeselect: function () {
      this._closePopup();
    },

    _attachListeners: function (evt) {
      document
        .querySelector('[data-action="close-popup"]')
        .addEventListener("click", this._closePopup.bind(this));
    },

    _openPopup: function (evt) {
      this.element.setAttribute("aria-hidden", "false");
      localStorage.setItem("themePopup", "true");
    },

    _closePopup: function (evt) {
      this.element.setAttribute("aria-hidden", "true");
      localStorage.setItem("newsletter", new Date().getTime());
    },
  }
);

theme.ImageGridSlideshow = (function () {
  function ImageGridSlideshow(container) {
    var sectionId = container.dataset.sectionId;
    this.container = container;
    var slideshow = (this.slideshow = "#image-grid-" + sectionId);

    this.ImageGridSlider = new Swiper(slideshow, {
      slidesPerView: 1,
      spaceBetween: 0,
      grabCursor: false,
      keyboard: {
        enabled: true,
      },
      // Responsive breakpoints
      breakpoints: {
        1008: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
      },
      navigation: {
        nextEl: ".slide-button-next",
        prevEl: ".slide-button-prev",
      },
    });
  }

  return ImageGridSlideshow;
})();

theme.ImageGridSlideshow.prototype = Object.assign(
  {},
  theme.ImageGridSlideshow.prototype,
  {
    onUnload: function () {
      this.ImageGridSlider.destroy(true);
    },

    onBlockSelect: function (evt) {
      // Get slide's index using theme editor's id
      // Go to selected slide, pause auto-rotate
      var slideIndex = evt.target.getAttribute("data-slide-index");
      this.ImageGridSlider.slideTo(slideIndex - 1, 400, true);
    },

    onBlockDeselect: function (evt) {
      // Resume Slideshow events
      this.ImageGridSlider.update();
    },
  }
);

class CartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("cart-recommendations");
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}
customElements.define("cart-recommendations", CartRecommendations);

class SwatchSelects extends HTMLElement {
  constructor() {
    super();

    this.productCard = this.closest("upsell-product");
    this.productLink = this.productCard.querySelector(
      ".ProductItem__ImageWrapper"
    );
    this.addEventListener("change", this.onSwatchChange);
    this.button = this.productCard.querySelector('[data-action="add-to-cart"]');
  }

  onSwatchChange(event) {
    this.selected = event.target;
    this.selectedOption = event.target.options[event.target.selectedIndex];
    this.selectedVariantUrl = this.selectedOption.dataset.variantUrl;
    this.selectedVariantId = this.selectedOption.dataset.variantId;
    this.selectedVariantAvailability =
      this.selectedOption.dataset.variantAvailability;
    this.buttonText = this.selectedOption.dataset.buttonText;
    // this.updateLinks();
    this.updateVariantId();
    this.updateButton();
  }

  updateVariantId() {
    this.productCard.querySelector('[name="id"]').value =
      this.selectedVariantId;
  }

  updateButton() {
    this.button.innerHTML = this.buttonText;
    if (this.selectedVariantAvailability)
      var isVariantAvailabilitySet =
        this.selectedVariantAvailability?.toLowerCase?.() === "true";
    if (isVariantAvailabilitySet == false) {
      this.button.disabled = true;
    } else {
      this.button.disabled = false;
    }
  }

  updateLinks() {
    this.productLink.setAttribute("href", this.selectedVariantUrl);
  }
}
customElements.define("swatch-selects", SwatchSelects);

if (!customElements.get("upsell-form")) {
  customElements.define(
    "upsell-form",
    class UpsellForm extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.form = this;
        this.form.querySelector("[name=id]").disabled = false;
        this.form
          .querySelector('[data-action="add-to-cart"]')
          .addEventListener("click", this.onSubmitHandler.bind(this));
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const submitButton = this.querySelector('[data-action="add-to-cart"]');
        if (submitButton.classList.contains("loading")) return;

        this.handleErrorMessage();

        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");
        document.dispatchEvent(new CustomEvent("theme:loading:start")); // Then we add the product in Ajax

        var inputValue = this.form.querySelector("[name=id]").value;

        let formData = {
          items: [
            {
              id: inputValue,
            },
          ],
        };

        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
          .then((response) => response.json())
          .then((response) => {
            document.dispatchEvent(new CustomEvent("theme:loading:end"));
            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            }

            if (window.theme.cartType === "drawer") {
              var quantityElement =
                this.form.querySelector('[name="quantity"]');
              // We simply trigger an event so the mini-cart can re-render
              this.dispatchEvent(
                new CustomEvent("product:added", {
                  bubbles: true,
                  detail: {
                    quantity: quantityElement
                      ? parseInt(quantityElement.value)
                      : 1,
                  },
                })
              );
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("aria-disabled");
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
class SmoothScroller {
  constructor() {
    this.links = document.querySelectorAll('a[href^="#"]');
    if (!this.links.length) return; // Exit early if no matching links
    this.handleClick = this.handleClick.bind(this);
    this.links.forEach((link) =>
      link.addEventListener("click", this.handleClick)
    );

    this.header = document.querySelector('.shopify-section--header');
    this.offset = this.header ? this.header.offsetHeight : 0;

    if (this.header && window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver(entries => {
        for (let entry of entries) {
          if (entry.target === this.header) {
            this.offset = entry.contentRect.height;
          }
        }
      });
      this.resizeObserver.observe(this.header);
    }

  }
  handleClick(event) {
    event.preventDefault();
    const href = event.currentTarget.getAttribute("href");
    if (!href || href.length < 2) return; // Guard: href must be at least "#x"
    const targetId = href.slice(1);
    const targetElement = document.getElementById(targetId);
    if (!targetElement) return; // Guard: target element must exist

    const elementTop = targetElement.getBoundingClientRect().top + window.pageYOffset;

    // Scroll smoothly to the target element's top position
    window.scrollTo({
          top: elementTop - this.offset,
          behavior: 'smooth'
        });
    // Remove any hash from the URL without affecting scroll position
    if (history.replaceState) {
      history.replaceState(
        null,
        "",
        window.location.pathname + window.location.search
      );
    }
  }
}

// Load Default and Common Function
(function () {
  theme.collapsibles.init();
  // theme.DescriptionTabs();
})();

// Intialize all function on DOMLoaded
document.addEventListener("DOMContentLoaded", function () {
  var sections = new theme.Sections();

  new SmoothScroller();
  theme.collapsibles.init();

  sections.register('header', theme.HeaderSection);
  sections.register("cart-drawer", theme.CartDrawerAjax);
  sections.register("featured-video", theme.VideoSection);
  sections.register("collection-list", theme.CollectionListSlider);
  sections.register("product-list", theme.ProductListSlider);
  sections.register("testimonial", theme.Testimonial);
  sections.register("slideshow", theme.Slideshow);
  sections.register("slideshow-second", theme.SecondSlideshow);
  sections.register("main-product", theme.Product);
  sections.register("newsletter-popup", theme.NewsletterPopupSection);
  sections.register("image-grid-section", theme.ImageGridSlideshow);

  if (document.fonts) {
    document.fonts.ready.then(function () {
      window.performance.mark("theme:fonts_loaded");
    });
  }

  document.dispatchEvent(new CustomEvent("page:loaded"));
});

(function () {
  /**
   * ----------------------------------------------------------------------------
   * Size Chart
   * ----------------------------------------------------------------------------
   */
  (function () {
    function executeScripts(container) {
      const scripts = container.querySelectorAll("script");
      scripts.forEach((oldScript) => {
        const newScript = document.createElement("script");

        // Copy all attributes (data-src, data-package, src, type, etc.)
        Array.from(oldScript.attributes).forEach((attr) => {
          newScript.setAttribute(attr.name, attr.value);
        });

        // Copy inline script content
        if (oldScript.innerHTML) {
          newScript.innerHTML = oldScript.innerHTML;
        }

        oldScript.parentNode.replaceChild(newScript, oldScript);
      });
    }

    function injectContent(html) {
      const contentEl = document.querySelector(".SizeChart__Content");
      if (!contentEl) return;
      contentEl.innerHTML = html;
      executeScripts(contentEl);

      // Upgrade div[is="size-chart"] to <size-chart> custom elements
      contentEl.querySelectorAll('div[is="size-chart"]').forEach((div) => {
        const sizeChart = document.createElement("size-chart");
        while (div.firstChild) {
          sizeChart.appendChild(div.firstChild);
        }
        div.parentNode.replaceChild(sizeChart, div);
      });
    }

    function loadSizeChartContent() {
      const popupModal = document.querySelector("[data-popup-modal]");
      if (!popupModal) return;

      const sizeChartUrl = popupModal.dataset.sizeChartUrl;
      if (!sizeChartUrl) return;

      const CACHE_KEY = `theme:size-guide:${sizeChartUrl}`;

      try {
        const cached = sessionStorage.getItem(CACHE_KEY);
        if (cached) {
          injectContent(cached);
          return;
        }
      } catch (e) {
        // Safari in private mode does not allow getting item, we silently fail
      }

      fetch(sizeChartUrl)
        .then((res) => res.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");
          const sizeGuide = doc.getElementById("MainContent");
          if (sizeGuide) {
            const content = sizeGuide.innerHTML;
            try {
              sessionStorage.setItem(CACHE_KEY, content);
            } catch (e) {
              // Safari in private mode does not allow setting item, we silently fail
            }
            injectContent(content);
          }
        })
        .catch((err) => console.error("Size chart failed to load:", err));
    }

    loadSizeChartContent();

    // Use event delegation so dynamically-injected .popup-trigger elements
    // (e.g. after a product variation AJAX swap) work without re-binding.
    document.addEventListener("click", (e) => {
      const trigger = e.target.closest(".popup-trigger");
      if (!trigger) return;
      const bodyBlackout = document.querySelector(".SizeChart_Overlay");

      const { popupTrigger } = trigger.dataset;
      const popupModal = document.querySelector(
        `[data-popup-modal="${popupTrigger}"]`
      );

      if (!popupModal) return;
      popupModal.classList.add("is--visible");
      bodyBlackout?.classList.add("is-visible");

      popupModal
        .querySelector(".popup-modal__close")
        .addEventListener("click", () => {
          popupModal.classList.remove("is--visible");
          bodyBlackout?.classList.remove("is-visible");
        }, { once: true });

      if (bodyBlackout) {
        bodyBlackout.addEventListener("click", () => {
          popupModal.classList.remove("is--visible");
          bodyBlackout.classList.remove("is-visible");
        }, { once: true });
      }

      document.onkeydown = function (evt) {
        evt = evt || window.event;
        if (evt.keyCode == 27) {
          popupModal.classList.remove("is--visible");
          bodyBlackout?.classList.remove("is-visible");
        }
      };
    });
  })();
})();

(function () {
  /**
   * ----------------------------------------------------------------------------
   * RTE
   * ----------------------------------------------------------------------------
   */
  (function () {
    // We wrap each RTE table by a specific class to allow wrapping
    var Dom = document.body;
    Dom.querySelectorAll(".Rte table").forEach(function (table) {
      table.outerHTML =
        '<div class="TableWrapper">' + table.outerHTML + "</div>";
    });
    Dom.querySelectorAll(".Rte iframe").forEach(function (iframe) {
      // We scope the wrapping only for YouTube and Vimeo
      if (
        iframe.src.indexOf("youtube") !== -1 ||
        iframe.src.indexOf("youtu.be") !== -1 ||
        iframe.src.indexOf("vimeo") !== -1
      ) {
        iframe.outerHTML =
          '<div class="VideoWrapper">' + iframe.outerHTML + "</div>"; // Re-set the src attribute on each iframe after page load for Chrome's "incorrect iFrame content on 'back'" bug.
        // https://code.google.com/p/chromium/issues/detail?id=395791. Need to specifically target video and admin bar

        iframe.src = iframe.src;
      }
    });
  })();
})();


/*============================================================================
  Product FG Modal
==============================================================================*/

class HoldingModal extends HTMLElement {
  constructor() {
    super();
    this.el = this;
    this.inner = this.querySelector("[data-tool-tip-inner]");
    this.closeButton = this.querySelector("[data-tool-tip-close]");
    this.toolTipContent = this.querySelector("[data-tool-tip-content]");

    this.triggers = document.querySelectorAll("[data-tool-tip-trigger]");

    document.addEventListener("holdingmodal:open", (e) => {
      this._open(e.detail.context, e.detail.content);
    });
  }

  _open(context, insertedHtml) {
    //this.toolTipContent.innerHTML = insertedHtml;

    theme.a12y.trapFocus({
      container: this.el,
      namespace: "holdingmodal_focus",
    });

    if (this.closeButton) {
      this.closeButton.on("click" + ".holdingmodal-close", () => {
        this._close();
      });
    }

    document.documentElement.on(
      "click" + ".holdingmodal-outerclick",
      (event) => {
        if (
          this.el.dataset.toolTipOpen === "true" &&
          !this.inner.contains(event.target)
        )
          this._close();
      }
    );

    document.documentElement.on("keydown" + ".holdingmodal-esc", (event) => {
      if (event.code === "Escape") this._close();
    });

    this.el.dataset.toolTipOpen = true;
    this.el.dataset.toolTip = context;
  }

  _close() {
    //this.toolTipContent.innerHTML = '';
    this.el.dataset.toolTipOpen = "false";
    this.el.dataset.toolTip = "";

    theme.a12y.removeTrapFocus({
      container: this.el,
      namespace: "pfgmodal_focus",
    });

    this.closeButton.off("click" + ".holdingmodal-close");
    document.documentElement.off("click" + ".holdingmodal-outerclick");
    document.documentElement.off("keydown" + ".holdingmodal-esc");
  }
}

customElements.define("holding-modal", HoldingModal);

/*============================================================================
  FG Modal Trigger
==============================================================================*/

class HoldingTrigger extends HTMLElement {
  constructor() {
    super();
    this.el = this;
    this.toolTipContent = this.querySelector("[data-tool-tip-content]");

    this.init();
  }

  init() {
    //Create and dispatch customEvent
    const toolTipOpen = new CustomEvent("holdingmodal:open", {
      detail: {
        context: this.dataset.toolTip,
        content: this.toolTipContent.innerHTML,
      },
      bubbles: true,
    });

    this.el.addEventListener("click", (e) => {
      e.stopPropagation();
      this.dispatchEvent(toolTipOpen);
    });
  }
}

customElements.define("holding-trigger", HoldingTrigger);

/**
 * Swatch - Radios
 */
class SwatchRadios extends HTMLElement {
  constructor() {
    super();

    this.productCard = this.closest("[data-product-card]");
    this.productMediaLink = this.productCard.querySelector(
      ".product-card-media__link"
    );
    this.productImage = this.productCard.querySelector(
      ".product-card__featured-image"
    );
    this.revealImage = this.productCard?.querySelector(".RevealImage");
    this.productLink = this.productCard.querySelector(
      ".product-card--title__link"
    );

    this.addEventListener("change", this.onSwatchChange);
  }

  onSwatchChange(event) {
    this.selected = event.target;
    this.selectedVariantUrl = this.selected.dataset.variantUrl;
    this.selectedVariantImage = this.selected.dataset.variantImage;
    this.selectedVariantSecondaryImage = this.selected.dataset.imageSecondary;

    if (this.selectedVariantImage) {
      this.updateImage();
    }
    this.updateLinks();
  }

  updateImage() {
    this.productImage.src = this.selectedVariantImage;
    this.productImage.srcset = "";
    this.productImage.sizes = "";

    // Check if both the reveal image element and the secondary image data exist
    if (this.revealImage && this.selectedVariantSecondaryImage) {
      this.revealImage.src = this.selectedVariantSecondaryImage;
      this.revealImage.srcset = "";
      this.revealImage.sizes = "";
      this.revealImage.style.display = ""; // Ensures it's visible if previously hidden
    } else if (this.revealImage) {
      // Optional: Hide or clear the secondary image if the variant doesn't have one
      this.revealImage.src = "";
      this.revealImage.srcset = "";
    }
  }

  updateLinks() {
    this.productMediaLink.setAttribute("href", this.selectedVariantUrl);
    this.productLink.setAttribute("href", this.selectedVariantUrl);
  }
}

customElements.define("swatch-radios", SwatchRadios);

class MulticolumnSelects extends HTMLElement {
  constructor() {
    super();
    this.selectElement = this.querySelector("select");
    this.levels = this.querySelectorAll("[data-content]");
    this.selectElement.addEventListener(
      "change",
      this.handleSelectChange.bind(this)
    );
  }
  handleSelectChange() {
    const selectedOption =
      this.selectElement.options[this.selectElement.selectedIndex];
    const targetId = selectedOption.getAttribute("data-controls");
    // Remove active class from all levels
    this.levels.forEach((level) => {
      level.classList.remove("active");
    });
    // Add active class to the selected level
    const targetLevel = this.querySelector(`#${targetId}`);
    if (targetLevel) {
      targetLevel.classList.add("active");
    }
  }
}
customElements.define("multicolumn-selects", MulticolumnSelects);

if (!customElements.get("image-scroll")) {
  class ImageScroll extends HTMLElement {
    constructor() {
      super();
      // The constructor should only be used for basic setup,
      // like setting up shadow DOM, but not for querying children.
    }

    connectedCallback() {
      const stickyParentSection = this.querySelector("[data-sticky-parent]");
      const stickyContentWrapper = this.querySelector("[data-sticky-content]");
      const images = this.querySelectorAll("[data-image-scroll-media] img");

      const imageFrame1 = images[0];
      const imageFrame2 = images[1];
      const imageFrame3 = images[2] || null;

      if (
        !stickyParentSection ||
        !stickyContentWrapper ||
        !imageFrame1 ||
        !imageFrame2
      ) {
        console.error(
          "Error: Required elements not found in this specific ImageScroll section.",
          this
        );
        return;
      }

      const animateOnScroll = () => {
        const currentScroll = window.scrollY;
        const animationScrollRange =
          stickyParentSection.clientHeight - stickyContentWrapper.clientHeight;
        let scrollProgress =
          (currentScroll - stickyParentSection.offsetTop) /
          animationScrollRange;
        scrollProgress = Math.min(1, Math.max(0, scrollProgress));

        const img1ActiveEnd = 0.2;
        const img1FadeOutEnd = 0.4;
        const img2FadeInStart = 0.3;
        const img2ActiveEnd = 1.0;

        // --- Animation for Image Frame 1 ---
        let opacity1 = 0;
        let scale1 = 0.8;
        let grayscale1 = 100;
        let blur1 = 5;

        if (scrollProgress <= img1ActiveEnd) {
          opacity1 = 1;
          scale1 = 1;
          grayscale1 = 0;
          blur1 = 0;
        } else if (
          scrollProgress > img1ActiveEnd &&
          scrollProgress <= img1FadeOutEnd
        ) {
          const fadeOutProgress =
            (scrollProgress - img1ActiveEnd) / (img1FadeOutEnd - img1ActiveEnd);
          opacity1 = 1 - fadeOutProgress;
          scale1 = 1 - fadeOutProgress * 0.2;
          grayscale1 = fadeOutProgress * 100;
          blur1 = fadeOutProgress * 5;
        } else {
          opacity1 = 0;
          scale1 = 0.8;
          grayscale1 = 100;
          blur1 = 5;
        }
        imageFrame1.style.opacity = opacity1;
        imageFrame1.style.transform = `scale(${scale1.toFixed(2)})`;
        imageFrame1.style.filter = `grayscale(${grayscale1.toFixed(
          2
        )}%) blur(${blur1.toFixed(2)}px)`;

        // --- Animation for Image Frame 2 ---
        let opacity2 = 0;
        let scale2 = 0.8;
        let grayscale2 = 100;
        let blur2 = 5;

        if (scrollProgress < img2FadeInStart) {
          opacity2 = 0;
          scale2 = 0.8;
          grayscale2 = 100;
          blur2 = 5;
        } else if (
          scrollProgress >= img2FadeInStart &&
          scrollProgress <= img2ActiveEnd
        ) {
          const fadeInProgress =
            (scrollProgress - img2FadeInStart) /
            (img2ActiveEnd - img2FadeInStart);
          opacity2 = Math.min(1, fadeInProgress);
          scale2 = 0.8 + fadeInProgress * 0.2;
          grayscale2 = 100 - fadeInProgress * 100;
          blur2 = 5 - fadeInProgress * 5;
          if (scrollProgress >= img2ActiveEnd) {
            opacity2 = 1;
            scale2 = 1;
            grayscale2 = 0;
            blur2 = 0;
          }
        }
        imageFrame2.style.opacity = opacity2;
        imageFrame2.style.transform = `scale(${scale2.toFixed(2)})`;
        imageFrame2.style.filter = `grayscale(${grayscale2.toFixed(
          2
        )}%) blur(${blur2.toFixed(2)}px)`;

        // --- Handle Image Frame 3 (if it exists) ---
        if (imageFrame3) {
          let opacity3 = 0;
          let scale3 = 0.8;
          let grayscale3 = 100;
          let blur3 = 5;

          const img3FadeInStart = 0.8;
          const img3ActiveEnd = 1.0;

          if (scrollProgress < img3FadeInStart) {
            opacity3 = 0;
            scale3 = 0.8;
            grayscale3 = 100;
            blur3 = 5;
          } else if (
            scrollProgress >= img3FadeInStart &&
            scrollProgress <= img3ActiveEnd
          ) {
            const fadeInProgress =
              (scrollProgress - img3FadeInStart) /
              (img3ActiveEnd - img3FadeInStart);
            opacity3 = Math.min(1, fadeInProgress);
            scale3 = 0.8 + fadeInProgress * 0.2;
            grayscale3 = 100 - fadeInProgress * 100;
            blur3 = 5 - fadeInProgress * 5;
            if (scrollProgress >= img3ActiveEnd) {
              opacity3 = 1;
              scale3 = 1;
              grayscale3 = 0;
              blur3 = 0;
            }
          } else {
            opacity3 = 1;
            scale3 = 1;
            grayscale3 = 0;
            blur3 = 0;
          }
          imageFrame3.style.opacity = opacity3;
          imageFrame3.style.transform = `scale(${scale3.toFixed(2)})`;
          imageFrame3.style.filter = `grayscale(${grayscale3.toFixed(
            2
          )}%) blur(${blur3.toFixed(2)}px)`;
        }
      };

      // Add event listener and trigger once to set initial state
      window.addEventListener("scroll", animateOnScroll);
      animateOnScroll();
    }
  }

  customElements.define("image-scroll", ImageScroll);
}

/*============================================================================
     Sticky Video
  ==============================================================================*/
class StickyPopupManager extends HTMLElement {
  constructor() {
    super();

    this.popup = this;
    this.closeBtn = this.querySelector("#closePopup");
    this.collapseBtn = this.querySelector("#collapsePopup");
    this.startBtn = this.querySelector("#startButton");
    this.calendarModal = this.querySelector("#calendarModal");
    this.modalClose = this.querySelector("#modalClose");
    this.videoElement = this.querySelector(".js-video");
    this.isExpanded = false;

    window.addEventListener("pageshow", (event) => {
      this.init();
    });
  }

  init() {
    // Check if popup was already closed in this session
    if (sessionStorage.getItem("popupClosed") === "true") {
      return;
    } // Adjust threshold as needed (e.g., 0.8 means 80% of the video is visible)

    // Show popup after 5 seconds
    setTimeout(() => {
      this.showPopup();
    }, 6000);

    // Bind events
    this.popup.addEventListener("click", (e) => {
      // Don't expand if clicking on close button or start button
      if (
        e.target === this.closeBtn ||
        e.target === this.startBtn ||
        e.target === this.collapseBtn
      ) {
        return;
      }
      if (!this.isExpanded) {
        this.expandPopup();
      }
    });

    if (this.closeBtn) {
      this.closeBtn.addEventListener("click", (e) => {
        e.stopPropagation();
        this.closePopup();
      });
    }

    if (this.collapseBtn) {
      this.collapseBtn.addEventListener("click", (e) => {
        e.stopPropagation();
        this.collapsePopup();
      });
    }

    if (this.startBtn) {
      this.startBtn.addEventListener("click", (e) => {
        e.stopPropagation();
        this.openCalendar();
      });
    }

    if (this.modalClose) {
      this.modalClose.addEventListener("click", () => this.closeCalendar());
    }

    // Close modal when clicking outside
    if (this.calendarModal) {
      this.calendarModal.addEventListener("click", (e) => {
        if (e.target === this.calendarModal) {
          this.closeCalendar();
        }
      });
    }

    // Close modal with Escape key
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.calendarModal.classList.contains("show")) {
        this.closeCalendar();
      }
    });

    // Close popup when clicking outside (only when expanded)
    document.addEventListener("click", (e) => {
      if (this.isExpanded && !this.popup.contains(e.target)) {
        this.collapsePopup();
      }
    });
  }

  showPopup() {
    this.popup.classList.add("show");
    // Load and play the video when it enters the viewport
    for (var source in this.videoElement.children) {
      var videoSource = this.videoElement.children[source];
      if (
        typeof videoSource.tagName === "string" &&
        videoSource.tagName === "SOURCE"
      ) {
        videoSource.src = videoSource.dataset.src;
      }
    }

    this.videoElement.load();
    this.videoElement.play();
  }

  expandPopup() {
    this.popup.classList.add("expanded");
    this.isExpanded = true;
    this.videoElement.muted = false;
    this.videoElement.currentTime = 0;
  }

  collapsePopup() {
    this.popup.classList.remove("expanded");
    this.isExpanded = false;
    this.videoElement.muted = true;
  }

  closePopup() {
    this.popup.classList.remove("show", "expanded");
    this.isExpanded = false;
    // Remember that popup was closed for this session
    sessionStorage.setItem("popupClosed", "true");

    // Remove popup from DOM after animation
    setTimeout(() => {
      this.popup.style.display = "none";
      this.videoElement.pause();
      this.remove();
    }, 400);
  }

  openCalendar() {
    this.calendarModal.classList.add("show");
    document.body.style.overflow = "hidden"; // Prevent background scrolling
  }

  closeCalendar() {
    this.calendarModal.classList.remove("show");
    document.body.style.overflow = ""; // Restore scrolling
  }
}

customElements.define("sticky-video", StickyPopupManager);

/*============================================================================
     Modal
  ==============================================================================*/
class ToolTip extends HTMLElement {
  constructor() {
    super();
    this.el = this;
    this.inner = this.querySelector("[data-tool-tip-inner]");
    this.closeButton = this.querySelector("[data-tool-tip-close]");
    this.toolTipContent = this.querySelector("[data-tool-tip-content]");

    this.triggers = document.querySelectorAll("[data-tool-tip-trigger]");

    document.addEventListener("platinummodal:open", (e) => {
      this._open(e.detail.context, e.detail.content);
    });
  }

  _open(context, insertedHtml) {
    this.originalToolTipContent = insertedHtml;
    this.wrappedToolTipContent = `<div class="table-wrapper">${this.originalToolTipContent}</div>`;
    this.toolTipContent.innerHTML = this.wrappedToolTipContent;

    // this.toolTipContent.innerHTML = insertedHtml;
    // $(this.toolTipContent).wrap('<div class="table-wrapper"></div>');

    theme.a12y.trapFocus({
      container: this.el,
      namespace: "platinummodal_focus",
    });

    if (this.closeButton) {
      this.closeButton.on("click" + ".platinummodal-close", () => {
        this._close();
      });
    }

    document.documentElement.on(
      "click" + ".platinummodal-outerclick",
      (event) => {
        if (
          this.el.dataset.toolTipOpen === "true" &&
          !this.inner.contains(event.target)
        )
          this._close();
      }
    );

    document.documentElement.on("keydown" + ".platinummodal-esc", (event) => {
      if (event.code === "Escape") this._close();
    });

    this.el.dataset.toolTipOpen = true;
    this.el.dataset.toolTip = context;
  }

  _close() {
    this.toolTipContent.innerHTML = "";
    this.el.dataset.toolTipOpen = "false";
    this.el.dataset.toolTip = "";

    theme.a12y.removeTrapFocus({
      container: this.el,
      namespace: "platinummodal_focus",
    });

    this.closeButton.off("click" + ".platinummodal-close");
    document.documentElement.off("click" + ".platinummodal-outerclick");
    document.documentElement.off("keydown" + ".platinummodal-esc");
  }
}

customElements.define("tool-tip", ToolTip);

/*============================================================================
     Modal Trigger
  ==============================================================================*/
class ToolTipTrigger extends HTMLElement {
  constructor() {
    super();
    this.el = this;
    this.toolTipContent = this.querySelector("[data-tool-tip-content]");

    this.init();
  }

  init() {
    //Create and dispatch customEvent
    const toolTipOpen = new CustomEvent("platinummodal:open", {
      detail: {
        context: this.dataset.toolTip,
        content: this.toolTipContent.innerHTML,
      },
      bubbles: true,
    });

    this.el.addEventListener("click", (e) => {
      e.stopPropagation();
      this.dispatchEvent(toolTipOpen);
    });
  }
}

customElements.define("tool-tip-trigger", ToolTipTrigger);

/*============================================================================
     Quiz Modal
  ==============================================================================*/
  class QuizToolTip extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.inner = this.querySelector("[data-tool-tip-inner]");
      this.closeButton = this.querySelector("[data-tool-tip-close]");
      this.toolTipContent = this.querySelector("[data-tool-tip-content]");
  
      this.triggers = document.querySelectorAll("[data-tool-tip-trigger]");
  
      document.addEventListener("quizmodal:open", (e) => {
        this._open(e.detail.context, e.detail.content);
      });
    }
  
    _open(context, insertedHtml) {
      // this.toolTipContent.innerHTML = insertedHtml;
      // console.log(insertedHtml);
      // this.toolTipContent.innerHTML = '';
      if (this.toolTipContent) {
        this.toolTipContent.appendChild(insertedHtml);
      }
  
      theme.a12y.trapFocus({
        container: this.el,
        namespace: "quizmodal_focus",
      });
  
      if (this.closeButton) {
        this.closeButton.on("click" + ".quizmodal-close", () => {
          this._close();
        });
      }
  
      // UPDATED: Better outer click detection
      document.documentElement.on(
        "click" + ".quizmodal-outerclick",
        (event) => {
          if (this.el.dataset.toolTipOpen === "true") {
            // Check if click is on the modal backdrop (not inner content)
            const clickedElement = event.target;
            const isInnerClick = this.inner.contains(clickedElement);
            const isModalBackdrop = clickedElement === this.el;
            
            // Only close if clicked on backdrop or truly outside
            if (!isInnerClick || isModalBackdrop) {
              // Additional check: don't close if clicking quiz elements during re-render
              if (!clickedElement.closest('bahe-quiz') && !clickedElement.classList.contains('quiz-next-button')) {
                this._close();
              }
            }
          }
        }
      );
  
      document.documentElement.on("keydown" + ".quizmodal-esc", (event) => {
        if (event.code === "Escape") this._close();
      });
  
      this.el.dataset.toolTipOpen = true;
      this.el.dataset.toolTip = context;
    }
  
    _close() {
      if (window.location.hash === '#quiz') {
        history.replaceState(null, '', window.location.pathname + window.location.search);
      }
      // this.toolTipContent.innerHTML = "";
      this.el.dataset.toolTipOpen = "false";
      this.el.dataset.toolTip = "";
  
      theme.a12y.removeTrapFocus({
        container: this.el,
        namespace: "quizmodal_focus",
      });
  
      this.closeButton.off("click" + ".quizmodal-close");
      document.documentElement.off("click" + ".quizmodal-outerclick");
      document.documentElement.off("keydown" + ".quizmodal-esc");
    }
  }
  
  customElements.define("quiz-modal", QuizToolTip);

/*============================================================================
    Quiz Modal Trigger
  ==============================================================================*/
  class QuizModalTrigger {
    constructor() {
      this.sectionId = 'dynamic-quiz';
      this.cachedQuizHTML = null;
      this.isFetching = false;
      this.init();
    }
  
    init() {
      this.initQuizTriggers();
      this.initHashOpen();

      const observer = new MutationObserver(() => {
        this.initQuizTriggers();
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    initHashOpen() {
      if (window.location.hash === '#quiz') {
        this.openQuizModal();
      }
      window.addEventListener('hashchange', () => {
        if (window.location.hash === '#quiz') {
          this.openQuizModal();
        }
      });
    }
  
    initQuizTriggers() {
      const triggers = document.querySelectorAll('a[href="#quiz"], button[data-quiz-trigger], [data-open-quiz]');
      
      triggers.forEach(trigger => {
        trigger.removeEventListener('click', this.handleTriggerClick);
        trigger.addEventListener('click', this.handleTriggerClick.bind(this));
      });
    }
  
    handleTriggerClick(e) {
      e.preventDefault();
      e.stopPropagation();
      
      this.openQuizModal();
    }
  
    async openQuizModal() {
      // Prevent multiple simultaneous fetches
      if (this.isFetching) return;
  
      // If we have cached HTML, use it immediately
      if (this.cachedQuizHTML) {
        this.dispatchModalEvent(this.cachedQuizHTML);
        return;
      }
  
      // Set fetching flag
      this.isFetching = true;
  
      try {
        // Fetch the section HTML from Shopify
        const response = await fetch(window.Shopify.routes.root + `?section_id=${this.sectionId}`);
        
        if (!response.ok) {
          throw new Error(`Failed to load quiz: ${response.status}`);
        }
        
        const sectionHTML = await response.text();
        const content = new DOMParser().parseFromString(sectionHTML, 'text/html').querySelector('template')?.content.cloneNode(true);
        
        // Cache the HTML for future use
        this.cachedQuizHTML = content;
        
        // Only dispatch modal event AFTER content is fully fetched
        this.dispatchModalEvent(content);
        
      } catch (error) {
        console.error('Error loading quiz:', error);
        
        // Show error message
        this.dispatchModalEvent(`
          <div style="padding: 40px; text-align: center;">
            <h3 style="color: #d9534f; margin-bottom: 10px;">Failed to load quiz</h3>
            <p>Please try again or contact support.</p>
          </div>
        `);
      } finally {
        // Reset fetching flag
        this.isFetching = false;
      }
    }
  
    dispatchModalEvent(content) {
      const quizModalOpen = new CustomEvent("quizmodal:open", {
        detail: {
          context: "quiz-modal",
          content: content
        },
        bubbles: true
      });
      
      document.dispatchEvent(quizModalOpen);
    }
  
    // Optional: Clear cache method (useful if quiz settings change)
    clearCache() {
      this.cachedQuizHTML = null;
    }
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.quizModalTrigger = new QuizModalTrigger();
    });
  } else {
    window.quizModalTrigger = new QuizModalTrigger();
  }

// Open the Klaviyo form based on any condition, such as on a button click or in your own code.
document.addEventListener('click', function (e) {
  var btn = e.target.closest('a[href^="#klaviyo-"], button[data-href^="#klaviyo-"]');
  if (!btn) { return; }

  var href    = btn.getAttribute('href') || btn.getAttribute('data-href');
  var formID  = href.replace('#klaviyo-', '');
  if (!formID) { return; }

  e.preventDefault();

  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', formID]);
});

// Display the Shopify Chat widget on a button click or #chat link click
function openShopifyChat() {
  const chat = document.querySelector('shopify-chat');
  if (chat) {
    chat.setAttribute('open', '');
    chat.setAttribute('is-open', 'true');
  } else {
    // Retry shortly if the widget script is still loading
    setTimeout(openShopifyChat, 300);
  }
}

document.querySelector('a[href="#chat"], [data-chat-trigger]')?.addEventListener('click', (e) => {
  e.preventDefault();
  openShopifyChat();
});

/* Log Theme Version - Don't copy any code from this site otherwise you may face copyright infringement case. */
if (console && console.log) {
  console.log(
    "Bahe (17.5.0) | Designed & Developed by Akshay Vaghasiya | Learn more at https://akshayvaghasiya.com"
  );
}
